import { addTranslations } from "@app/i18n";

export const RESOURCE_NAME = "ObjectiveBody";

export const keys = addTranslations(RESOURCE_NAME, {
    description_title: {
        en: "<strong>Description</strong> (optional)",
        fr: "<strong>Description</strong> (optionnel)",
    },
    description_placeholder: {
        en: "Write here a detailed description of your objective.",
        fr: "Précisez ici dans quel cadre cet objectif a été défini.",
    },
    description_subtitle: {
        en: "Provide details about your objective, including how targets were set, whether benchmarks or studies were used, and if it is science-based.",
        fr: "Fournissez des détails sur votre objectif, y compris comment les cibles ont été définies, si des références ou des études ont été utilisées, et s’il est fondé sur des données scientifiques.",
    },
    description_guidance: {
        en: "Provide details about your objective, including how targets were set, whether benchmarks or studies were used, and if it is science-based.",
        fr: "Fournissez des informations précises sur votre objectif : expliquez comment les cibles ont été définies, indiquez si vous vous êtes appuyés sur des études et précisez si l'objectif repose sur des données scientifiques.",
    },
    hint_text: {
        en: "Provide details about your objective, including how targets were set, whether benchmarks or studies were used, and if it is science-based.",
        fr: "Fournissez des détails sur votre objectif, y compris la manière dont les cibles ont été fixées, si des points de repère ou des études ont été utilisés, et s'il est basé sur la science.",
    },
    targets_subtitle: {
        en: "What are your targets?",
        fr: "Quels sont vos objectifs chiffrés?",
    },
    targets_guidance: {
        en: "Quantify and date your objectives with ambitious and realistic targets.",
        fr: "Quantifiez et datez vos objectifs avec des cibles ambitieuses et atteignables.",
    },
    define_value: {
        en: "Define value",
        fr: "Valeur",
    },
    cancel: {
        en: "Cancel",
        fr: "Annuler",
    },
    create: {
        en: "Create",
        fr: "Créer",
    },
    no_targets: {
        en: "No target defined",
        fr: "Cet objectif n'est pas chiffré",
    },
    no_indicator_targets: {
        en: "Add an indicator to the objective to define targets",
        fr: "Ajoutez un indicateur à l'objectif pour chiffrer vos objectifs",
    },
    target_description: {
        en: "Add a target to make this objective measurable.",
        fr: "Ajoutez un chiffre et une date pour rendre cet objectif mesurable.",
    },
    add_date: {
        en: "Add date",
        fr: "Ajouter une date",
    },
    error_value: {
        en: "Enter a valid value",
        fr: "Entrez une valeur valide",
    },
    indicator: {
        en: "Indicator selected:",
        fr: "Indicateur sélectionné :",
    },
    unit: {
        en: "Unit",
        fr: "Unité",
    },
    no_indicator_selected: {
        en: "No indicator attached",
        fr: "Pas d'indicateur associé",
    },
    no_indicator_selected_hint: {
        en: "Choose an indicator to measure and track progress toward this objective.",
        fr: "Choisissez un indicateur pour évaluer votre objectif et suivre votre progression.",
    },
    edit: {
        en: "Edit indicator",
        fr: "Modifier l'indicateur",
    },
    delete: {
        en: "Delete",
        fr: "Supprimer",
    },
    latest_value: {
        en: "Latest reporting value",
        fr: "Dernière valeur du reporting",
    },
    disabled_targets_tooltip: {
        en: "Cannot be edited if targets are set",
        fr: "Ne peut pas être modifié si des objectifs chiffrés sont définis",
    },
    show_example: {
        en: "Show example",
        fr: "Afficher un exemple",
    },
    update_success: {
        en: "Objective updated",
        fr: "Objectif mis à jour",
    },
    update_error: {
        en: "Error updating objective",
        fr: "Erreur lors de la mise à jour de l'objectif",
    },
    latest_period: {
        en: "Reported based on reporting data from {{period}}",
        fr: "Basé sur les données de reporting de {{period}}",
    },
    no_latest_period: {
        en: "No reporting data available",
        fr: "Aucune donnée reporting disponible",
    },
    targets: {
        en: "Targets",
        fr: "Cibles",
    },
    action_plan_placeholder: {
        en: "Define here specific steps or strategies you will follow to achieve your goals. You can revise this later as needed.",
        fr: "Définissez ici les étapes ou stratégies spécifiques que vous suivrez pour atteindre votre objectif. Vous pourrez les réviser ultérieurement si nécessaire.",
    },
    action_plan_title: {
        en: "<strong>Plan to reach target</strong> (optional)",
        fr: "<strong>Plan d'action</strong> (optionnel)",
    },
    action_plan_subtitle: {
        en: "Detail the specific actions or strategies you will take to reach this target. Update this plan over time.",
        fr: "Détaillez les actions que vous souhaitez mettre en œuvre pour atteindre cet objectif. Cette section peut être mise à jour au fil du temps pour vous aider à suivre et à gérer vos objectifs.",
    },
    action_plan_guidance: {
        en: "Detail the actions you plan to take to reach this target. This section can be updated over time to help track and manage your objectives.",
        fr: "Détaillez les actions que vous souhaitez mettre en œuvre pour atteindre cet objectif. Cette section peut être mise à jour au fil du temps pour vous aider à suivre et à gérer vos objectifs.",
    },
    include_details: {
        en: "Include additional details",
        fr: "Inclure des détails supplémentaires",
    },
});
